import "core-js/modules/es6.function.name";
import React from 'react';
import pick from 'lodash/pick';
import get from 'lodash/get';
import classNames from 'classnames';
import Link from '@nerdwallet/react-link';
import Type, { Heading } from '@nerdwallet/react-typography';
import List, { Li } from '@nerdwallet/react-list';
import Image from '@nerdwallet/react-image';
import style from '../html-to-nds.module.less';

var safeUrl = function safeUrl(node) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var onSafe = arguments.length > 2 ? arguments[2] : undefined;
  var onUnsafe = arguments.length > 3 ? arguments[3] : undefined;
  return String(url).indexOf('https://') === 0 ? onSafe() : onUnsafe();
};

var NDSLib = {
  ol: function ol(node, children) {
    return React.createElement(List, {
      ordered: true
    }, children);
  },
  ul: function ul(node, children) {
    return React.createElement(List, null, children);
  },
  li: function li(node, children) {
    return React.createElement(Li, null, children);
  },
  h1: function h1(node, children) {
    return React.createElement(Heading, {
      level: 1
    }, children);
  },
  h2: function h2(node, children) {
    return React.createElement(Heading, {
      level: 2
    }, children);
  },
  h3: function h3(node, children) {
    return React.createElement(Heading, {
      level: 3
    }, children);
  },
  h4: function h4(node, children) {
    return React.createElement(Heading, {
      level: 4
    }, children);
  },
  h5: function h5(node, children) {
    return React.createElement(Heading, {
      level: 5
    }, children);
  },
  h6: function h6(node, children) {
    return React.createElement(Type, {
      component: "h6",
      size: "2",
      bold: true
    }, children);
  },
  p: function p(node, children) {
    return React.createElement(Type, null, children);
  },
  a: function a(node, children) {
    return safeUrl(node, node.attribs.href, function () {
      return React.createElement(Link, pick(node.attribs, ['href', 'title', 'target']), children);
    }, function () {
      return React.createElement(Type, {
        inline: true
      }, children);
    });
  },
  b: function b(node, children) {
    return React.createElement(Type, {
      inline: true,
      bold: true
    }, children);
  },
  i: function i(node, children) {
    return React.createElement(Type, {
      inline: true,
      italic: true
    }, children);
  },
  sup: function sup(node, children) {
    return React.createElement(Type, {
      inline: true,
      className: classNames([style['nds-sup']])
    }, children);
  },
  '&reg;': function reg() {
    return '®';
  },
  '&copy;': function copy() {
    return '©';
  },
  '&#8480;': function _() {
    return '℠';
  },
  '&#x2120;': function x2120() {
    return '℠';
  },
  img: function img(node) {
    return safeUrl(node, node.attribs.src, function () {
      return React.createElement(Image, pick(node.attribs, ['src', 'title', 'alt', 'width', 'height']));
    }, function () {
      return get(node.attribs, 'alt', '') ? React.createElement(Type, {
        inline: true
      }, node.attribs.alt) : null;
    });
  },
  generic: function generic(node, children) {
    return React.createElement(Type, {
      inline: true,
      bold: node.name === 'strong',
      italic: node.name === 'em'
    }, children);
  }
};
export default NDSLib;